import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'uppercaseFirstLetterFirstWord',
})
export class UppercaseFirstLetterFirstWordPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value.toLowerCase().replace(/^(\s*\S)/, (match) => match.toUpperCase());
  }
}
